

(function () {
  'use strict';
  var root = document.querySelector('[data-tf]');
  if (!root) return;

  function arrancar() {
    var cv = root.querySelector('.tf__lienzo'), cx = cv.getContext('2d');
    var gv = root.querySelector('.tf__grano'), gx = gv.getContext('2d'), patron;
    var mv = document.createElement('canvas'), mx = mv.getContext('2d');
    (function () {
      var c = document.createElement('canvas'); c.width = c.height = 180;
      var x = c.getContext('2d'), d = x.createImageData(180, 180);
      for (var i = 0; i < d.data.length; i += 4) { var v = Math.random() * 255; d.data[i] = 94 + v * .4; d.data[i + 1] = 46 + v * .3; d.data[i + 2] = 32 + v * .25; d.data[i + 3] = Math.random() * 70; }
      x.putImageData(d, 0, 0); patron = gx.createPattern(c, 'repeat');
    })();
    var et = [0, 1, 2, 3].map(function (i) { return root.querySelector('[data-tf-et="' + i + '"]'); });

    var txt = [0, 1, 2, 3].map(function (i) {
      var li = root.querySelector('[data-tf-txt="' + i + '"]'), k = li.getAttribute('data-i18n');
      var d = window.VEVVIA_I18N && k && window.VEVVIA_I18N.t(k);
      return (d && d !== k ? d : li.textContent).trim();
    });
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var CICLO = 10;

    var ESF = [
      { base: [246, 222, 204], m: [[214, 104, 66], [234, 150, 110]], f: .36 },
      { base: [244, 225, 200], m: [[173, 86, 59], [235, 196, 150]], f: .3 },
      { base: [247, 228, 210], m: [[200, 92, 58], [222, 160, 120]], f: .4 }
    ];

    var W, H, R, movil, pos = [], centro;
    function medir() {
      var r = root.getBoundingClientRect();
      W = r.width; H = r.height;
      cv.width = Math.round(W * 0.6); cv.height = Math.round(H * 0.6);
      gv.width = Math.round(W); gv.height = Math.round(H); mv.width = gv.width; mv.height = gv.height;
      movil = W < 700;
      R = movil ? W * 0.21 : Math.min(W * 0.115, H * 0.2, 175);
      centro = [W / 2, movil ? H * 0.56 : H * 0.55];
      pos = movil
        ? [[W * 0.29, H * 0.43], [W * 0.71, H * 0.43], [W * 0.5, H * 0.72]]
        : [[W * 0.27, H * 0.56], [W * 0.5, H * 0.56], [W * 0.73, H * 0.56]];
      root.style.setProperty('--tf-blur', (movil ? 9 : 16) + 'px');
    }

    var ease = function (x) { x = Math.min(1, Math.max(0, x)); return x < .5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; };
    var tramo = function (t, a, b) { return ease((t - a) / (b - a)); };

    function escribir(i, t, desde, hasta, borrar) {
      var s = txt[i], n;
      if (t < desde) n = 0;
      else if (t < hasta) n = Math.round(s.length * (t - desde) / (hasta - desde));
      else if (t < borrar) n = s.length;
      else n = Math.max(0, Math.round(s.length * (1 - (t - borrar) / 0.4)));
      var span = et[i].querySelector('span');
      if (span.textContent.length !== n) span.textContent = s.slice(0, n);
      et[i].style.opacity = n > 0 || (t > desde - .3 && t < borrar + .4) ? 1 : 0;
      et[i].style.setProperty('--cursor', t > desde && t < borrar + .4 && (Math.floor(t * 3) % 2) ? .8 : 0);
    }

    function esfera(x, y, r, e, t, k, alfa) {
      var g = cx.createRadialGradient(x, y, 0, x, y, r);
      g.addColorStop(0, 'rgba(' + e.base + ',' + alfa + ')');
      g.addColorStop(.97, 'rgba(' + e.base + ',' + alfa + ')');
      g.addColorStop(1, 'rgba(' + e.base + ',0)');
      cx.fillStyle = g; cx.beginPath(); cx.arc(x, y, r, 0, 6.283); cx.fill();
      cx.save(); cx.beginPath(); cx.arc(x, y, r * .98, 0, 6.283); cx.clip();
      e.m.forEach(function (c, j) {
        var a = t * e.f * (j ? -1 : 1) + k * 2.1 + j * 2.6;
        var px = x + Math.cos(a) * r * .55, py = y + Math.sin(a * 1.3) * r * .5, pr = r * (j ? .7 : .85);
        var gm = cx.createRadialGradient(px, py, 0, px, py, pr);
        gm.addColorStop(0, 'rgba(' + c + ',' + (.95 * alfa) + ')');
        gm.addColorStop(1, 'rgba(' + c + ',0)');
        cx.fillStyle = gm; cx.fillRect(x - r, y - r, 2 * r, 2 * r);
      });
      cx.restore();
    }

    var t0 = null, visible = false, raf = 0;
    function cuadro(ahora) {
      raf = 0;
      if (!visible) return;
      if (t0 === null) t0 = ahora;
      var t = reduce ? 4 : ((ahora - t0) / 1000) % CICLO;
      var s = cv.width / W;
      cx.setTransform(s, 0, 0, s, 0, 0);
      cx.clearRect(0, 0, W, H);
      gx.globalCompositeOperation = 'source-over'; gx.clearRect(0, 0, W, H); gx.fillStyle = patron; gx.fillRect(0, 0, W, H);
      mx.clearRect(0, 0, W, H); mx.globalCompositeOperation = 'lighter';

      var junta = reduce ? 0 : tramo(t, 4.3, 5.4) * (1 - tramo(t, 8.6, 9.7));
      var crece = 1 + .55 * junta;
      var aparece = reduce ? 1 : tramo(t, 0, .6);
      var respira = reduce ? 1 : 1 + Math.sin(ahora / 900) * .018;
      ESF.forEach(function (e, k) {
        var x = pos[k][0] + (centro[0] - pos[k][0]) * junta;
        var y = pos[k][1] + (centro[1] - pos[k][1]) * junta;
        var rr = R * crece * respira;
        esfera(x, y, rr, e, reduce ? 0 : ahora / 1000, k, aparece);
        var gm = mx.createRadialGradient(x, y, rr * .45, x, y, rr * 1.08);
        gm.addColorStop(0, 'rgba(0,0,0,' + aparece + ')'); gm.addColorStop(1, 'rgba(0,0,0,0)');
        mx.fillStyle = gm; mx.fillRect(x - rr * 1.1, y - rr * 1.1, rr * 2.2, rr * 2.2);
        et[k].style.left = pos[k][0] + 'px'; et[k].style.top = pos[k][1] + 'px';
      });
      gx.globalCompositeOperation = 'destination-in'; gx.drawImage(mv, 0, 0); gx.globalCompositeOperation = 'source-over';
      et[3].style.left = centro[0] + 'px'; et[3].style.top = centro[1] + 'px';

      if (reduce) {
        [0, 1, 2].forEach(function (i) { et[i].querySelector('span').textContent = txt[i]; et[i].style.opacity = 1; });
        et[3].style.opacity = 0;
        return;
      }

      escribir(0, t, 0.4, 1.3, 3.6);
      escribir(1, t, 0.8, 1.7, 3.7);
      escribir(2, t, 1.2, 2.2, 3.8);
      escribir(3, t, 5.5, 6.6, 8.2);
      raf = requestAnimationFrame(cuadro);
    }
    function pedir() { if (!raf) raf = requestAnimationFrame(cuadro); }

    medir();
    addEventListener('resize', function () { medir(); pedir(); });
    new IntersectionObserver(function (es) {
      visible = es[0].isIntersecting;
      if (visible) { t0 = null; pedir(); }
    }, { threshold: .25 }).observe(root);
  }

  var i = window.VEVVIA_I18N;
  if (i && i.listo && i.listo.then) i.listo.then(arrancar, arrancar);
  else if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
